import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import reloadIcon from "../../assets/icons/reloadIcon.svg";

const ApiErrorPage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <h1 style={{ textAlign: "center", marginTop: "100px", marginBottom: "40px" }}>
        {t("The service is temporarily unavailable. Please try again later.")}
      </h1>

      <div className="d-flex justify-content-center">
        <Button variant="primary" size="lg" onClick={() => window.location.reload()}>
          <img src={reloadIcon} width={18} height={18} alt="Reload Alerts/ Remove Filters Icon" /> {t("Odśwież")}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default ApiErrorPage;
